import { useBillingLicensesSendSuspendAutoRenewalMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const useLicensesSuspendAutoRenewal = () => {
  const [mutation, mutationResult] = useBillingLicensesSendSuspendAutoRenewalMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (companyId: string, licensesIds: string[]) => {
    try {
      const mutationResult = await mutation({
        variables: {
          input: { licensesIds, companyId },
        },
      });

      return !!mutationResult.data?.result?.ok;
    } catch (e) {
      return false;
    }
  };

  const result = {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
  };

  return {
    request,
    result,
  };
};

export default useLicensesSuspendAutoRenewal;
